<script lang="ts">
	import { format } from 'svelte-i18n';
	import type { Device } from 'src/types/Device';
	import { Button, ButtonGroupV2 } from '@Shelly/shelly-design-system/index';
	import { routeToDeviceSettings } from 'src/stores/ui/route-to-device-settings';
	import CloudStorageSettings from './CloudStorageSettings.svelte';
	import LocalStorageSettings from './LocalStorageSettings.svelte';

	export let device: Device;

	type StorageTab = 'cloud' | 'local';
	let activeTab: StorageTab = 'cloud';

	$: if (
		$routeToDeviceSettings[device.id]?.setting === 'storage' &&
		$routeToDeviceSettings[device.id]?.subSetting === 'local'
	) {
		activeTab = 'local';
		routeToDeviceSettings.resetTarget();
	}
</script>

<div class="mb-s">
	<ButtonGroupV2
		aria-label={$format('label_camera_storage_type', { default: 'Storage type' })}
		noWrap
		class="width-full"
	>
		<Button
			class={`width-full ${activeTab === 'cloud' ? 'active' : ''}`}
			size="m"
			on:click={() => (activeTab = 'cloud')}
		>
			{$format('camera_storage_tab_cloud', { default: 'Cloud storage' })}
		</Button>
		<Button
			class={`width-full ${activeTab === 'local' ? 'active' : ''}`}
			size="m"
			on:click={() => (activeTab = 'local')}
		>
			{$format('camera_storage_tab_local', { default: 'Local storage' })}
		</Button>
	</ButtonGroupV2>
</div>

{#if activeTab === 'cloud'}
	<CloudStorageSettings {device} />
{:else}
	<LocalStorageSettings {device} />
{/if}
